const components = {}

export const registerUnpublishedComponents = (nextComponents) => {
  Object.assign(components, nextComponents)
}

export const resolveUnpublishedComponent = (documents) => (
  components[documents[0]?.type]
)
